export const languageElements = {
    items: {
        'alert-data-saved-successfully': {
            hu: 'Sikeres mentés',
            de: 'Daten erfolgreich gespeichert',
            en: 'Data saved',
        },

        'alert-data-some-fields-have-incorrect-content': {
            hu: 'Néhány mező tartalma hibás',
            de: 'Einige Felder enthalten falsche Werte',
            en: 'Some fields have incorrect content',
        },
    }
}
